<template>
    <div v-if="recommend.length" class="product_recommended">
        <div class="container">
            <div class="products collection posr">
                <h2 class="posr">{{ title }}</h2>
                <swiper :options="options">
                    <swiper-slide v-for="(item, index) in recommend" v-bind:key="index">
                        <ProductItem :product="item" />
                    </swiper-slide>
                </swiper>
                <div id="recommend-pagination" class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductItem from '@/components/products/items/Item'
    import classApi from '@/api/class'

    export default {
        components: {
            ProductItem
        },
        props: {
            title: {
                type: String,
                default() {
                    return '推薦課程';
                },
            },
            classId: {
                type: String,
                required: true,
                default() {
                    return '';
                },
            },
        },
        data() {
            return {
                options: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                    simulateTouch: false,
                    pagination: {
                        el: '#recommend-pagination',
                        clickable: true,
                    },
                    breakpoints: {
                        1920: {
                            spaceBetween: 10
                        },
                        1200: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                            simulateTouch: true
                        },
                        414: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                            simulateTouch: true
                        }
                    },
                },
                recommend: [],
            };
        },
        watch: {
            classId: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.getQueryRecommend();
                    }
                },
            },
        },
        methods: {
            getQueryRecommend() {
                this.recommend = [];
                classApi.queryRecommend({
                    ClassID: this.classId
                }, (data) => {
                    this.recommend = data ? data : [];
                })
            },
        },
    }
</script>